import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugin/main.css'
import { createI18n } from 'vue-i18n'
import jp from './locales/jp.json'
import vn from './locales/vn.json'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import AOS from 'aos'
import 'aos/dist/aos.css'
const vuetify = createVuetify({
  components,
  directives
})

// Định nghĩa các chuỗi ngôn ngữ
const messages = {
  jp: jp,
  vn: vn
}
const i18n = createI18n({
  locale: 'jp', // Ngôn ngữ mặc định
  fallbackLocale: 'vn', // Ngôn ngữ dự phòng
  messages
})

AOS.init({
  duration: 2000, // Thay đổi thời gian hiệu ứng (ms)
  once: false, // Hiệu ứng chỉ xảy ra một lần
  offset: 20
})
createApp(App).use(i18n).use(vuetify).use(store).use(router).mount('#app')
